module.exports = __webpack_public_path__ + "static/virtual-assistant-75f1ad415685d2911306493ccf50356f.svg";